'use strict';

import {animate, getVueTemplate} from '../../_imports/utils/utils.common';
import getCountdownLabel from './getCountdownLabel';
import showTimeLeftBeforeEvent from './showTimeLeftBeforeEvent';

const animationCollapse = 'slideUp';
const animationDuration = 400;
const animationEasing = 'easeInBack';

const collapseArguments = {
    properties: animationCollapse,
    options: {
        duration: animationDuration,
        easing: animationEasing
    }
};

const countdown = {
    template: getVueTemplate('countdown'),
    mixins: [
        getCountdownLabel,
        showTimeLeftBeforeEvent
    ],
    props: {
        eventStartDate: String,
        countdownMessage: String,
        background: String,
    },
    data() {
        return {
            eventDate: this.eventStartDate,
        };
    },
    methods: {
        leave(element) {
            animate(element, collapseArguments, {
                complete: () => {
                    let heroContainer = document.querySelector('.hero-event');
                    let formContainer = document.querySelector('.aside_box');

                    formContainer.classList.remove('with-countdown');

                    //check if hero only has .hero-event and .hero classes. If so, add the class .event-grey-diamond once the countdown is over
                    if (Object.values(heroContainer.classList).indexOf('hero-event') > -1 && Object.values(heroContainer.classList).indexOf('hero') > -1 && heroContainer.classList.length === 2) {
                        heroContainer.classList.add('event-grey-diamond');
                    }
                    return;
                }
            });
        }
    },
    mounted() {
        this.$root.$emit('countdown-activated');
        this.showTimeLeftBeforeEvent();
        let heroContainer = document.querySelector('.hero-event');
        let formContainer = document.querySelector('.aside_box');

        formContainer.classList.add('with-countdown');
        if (heroContainer.classList.contains('event-grey-diamond')) {
            heroContainer.classList.remove('event-grey-diamond');
        }
    }
};

export default countdown;